import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
    FETCH_SMS_MANAGEMENT_REQUEST,
    FETCH_SMS_MANAGEMENT_SUCCESS,
    FETCH_SMS_MANAGEMENT_FAILURE,
    FETCH_SMS_MANAGEMENT_BY_ID_REQUEST,
    FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS,
    FETCH_SMS_MANAGEMENT_BY_ID_FAILURE,
    CREATE_SMS_MANAGEMENT_REQUEST,
    CREATE_SMS_MANAGEMENT_SUCCESS,
    CREATE_SMS_MANAGEMENT_FAILURE,
    UPDATE_SMS_MANAGEMENT_REQUEST,
    UPDATE_SMS_MANAGEMENT_SUCCESS,
    UPDATE_SMS_MANAGEMENT_FAILURE,
    DELETE_SMS_MANAGEMENT_REQUEST,
    DELETE_SMS_MANAGEMENT_SUCCESS,
    DELETE_SMS_MANAGEMENT_FAILURE,
    fetchSmsManagementRequest,
} from '../actions/smsManagementActions';
import {
    getSmsManagement,
    getSmsManagementById,
    createSmsManagement,
    updateSmsManagement,
    deleteSmsManagement,
} from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

function* refetchSmsManagementList(overrides = {}) {
    const lastParams = yield select((state) => state.smsManagement.lastListParams);
    const params = { ...(lastParams || { skip: 0, limit: 10 }), ...overrides };
    yield put(fetchSmsManagementRequest(params));
}

function* fetchSmsManagementSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getSmsManagement, params);
        yield put({ type: FETCH_SMS_MANAGEMENT_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du SMS management');
        yield put({ type: FETCH_SMS_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

function* fetchSmsManagementByIdSaga(action) {
    try {
        const data = yield call(getSmsManagementById, action.payload);
        yield put({ type: FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du SMS management');
        yield put({ type: FETCH_SMS_MANAGEMENT_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* createSmsManagementSaga(action) {
    try {
        const { partnerId, smsManagementData } = action.payload;
        const data = yield call(createSmsManagement, partnerId, smsManagementData);
        yield put({ type: CREATE_SMS_MANAGEMENT_SUCCESS, payload: data });
        yield* refetchSmsManagementList({ skip: 0 });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création du SMS management');
        yield put({ type: CREATE_SMS_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

function* updateSmsManagementSaga(action) {
    try {
        const { smsManagementId, smsManagementData } = action.payload;
        const data = yield call(updateSmsManagement, smsManagementId, smsManagementData);
        yield put({ type: UPDATE_SMS_MANAGEMENT_SUCCESS, payload: data });
        yield* refetchSmsManagementList();
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour du SMS management');
        yield put({ type: UPDATE_SMS_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

function* deleteSmsManagementSaga(action) {
    try {
        yield call(deleteSmsManagement, action.payload);
        yield put({ type: DELETE_SMS_MANAGEMENT_SUCCESS, payload: action.payload });
        yield* refetchSmsManagementList();
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression du SMS management');
        yield put({ type: DELETE_SMS_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

export function* watchSmsManagementRequests() {
    yield takeEvery(FETCH_SMS_MANAGEMENT_REQUEST, fetchSmsManagementSaga);
    yield takeEvery(FETCH_SMS_MANAGEMENT_BY_ID_REQUEST, fetchSmsManagementByIdSaga);
    yield takeEvery(CREATE_SMS_MANAGEMENT_REQUEST, createSmsManagementSaga);
    yield takeEvery(UPDATE_SMS_MANAGEMENT_REQUEST, updateSmsManagementSaga);
    yield takeEvery(DELETE_SMS_MANAGEMENT_REQUEST, deleteSmsManagementSaga);
}
